module.exports = __webpack_public_path__ + "dacefb20f49064fca3170191ad70819a.woff2";


//////////////////
// WEBPACK FOOTER
// ./App/assets/camunda/fonts/opensans-light-webfont.woff2
// module id = 342
// module chunks = 0